import { render, staticRenderFns } from "./CustomerProfitability.vue?vue&type=template&id=873ab20a"
import script from "./CustomerProfitability.vue?vue&type=script&lang=js"
export * from "./CustomerProfitability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports